import { OrderDetail } from '@insurance/api/requests'
import { createContext, useContext } from 'react'

type CascoInsuranceValues = {
  isEditable: boolean
  order?: OrderDetail
}

const CascoInsuranceContext = createContext<CascoInsuranceValues>({
  isEditable: false
})

export const CascoInsuranceProvider = ({
  children,
  ...values
}: React.PropsWithChildren<CascoInsuranceValues>) => {
  return (
    <CascoInsuranceContext.Provider value={values}>
      {children}
    </CascoInsuranceContext.Provider>
  )
}

export const useCascoInsuranceValues = () => useContext(CascoInsuranceContext)
